import { useMutation } from 'react-query';
import { getProductReservationApi } from '../../../../../../config/SwaggerProductReservationApi';

const deletePlaceholderManagement = (id: string) =>
    getProductReservationApi()
        .placeholderSetting.deleteDelete(id)
        .then((response) => response.data);

const useDeletePlaceholderManagement = () => {
    const useDeletePlaceholderManagementMutation = useMutation(deletePlaceholderManagement);

    return useDeletePlaceholderManagementMutation;
};

export default useDeletePlaceholderManagement;
